export default __webpack_public_path__ + "static/media/ER1.b3dd7d68.png";